import { BaseSearchRequest } from "./base-search-request";

export class CommonRequest extends BaseSearchRequest {
  reportType?: string;
  customerId?: number;
  orderCode?: string;
  userIds?: number[];
  serviceCarIds?: number[];
  showSubCustomer?: boolean;
  orderIds?: number[];
  minAmount?: number;
  maxAmount?: number;
}
